import { listField, formFields } from "./config";
import component from "./OtherPayout.vue";

export default {
  component,
  listField,
  formFields,
};

export const selector = (selectedPayoutSystem: string | null): boolean => {
  return selectedPayoutSystem === "other";
};
